<script setup>
import {computed, defineProps} from "vue";
const props = defineProps({
  price: {
    type: String,
    required: true
  },

});

const formattedPrice = computed(() => {
  return (parseFloat(props.price.toString().replace('€', '').replace(',', '.'))).toFixed(2) + ' €';
});
</script>

<template>
  <span class="text-nowrap">{{ formattedPrice }}</span>
</template>
